/**
 * @generated SignedSource<<438bd754c35d42ffa023d274630325ee>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowSellerSince_viewer$data = {
  readonly suppressNewSellerSignals: boolean | null;
  readonly " $fragmentType": "useShowSellerSince_viewer";
};
export type useShowSellerSince_viewer$key = {
  readonly " $data"?: useShowSellerSince_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowSellerSince_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowSellerSince_viewer",
  "selections": [
    {
      "alias": "suppressNewSellerSignals",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "suppressNewSellerSignals"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"suppressNewSellerSignals\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "554ffd0a25ed1c25bd31f0bc20abc20a";

export default node;
